<template>
  <v-card class="create-rbu">
    <v-card-title>
      <!-- {{ title }} -->
      Edit ASor Rbu Item Description
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-text-field
          outlined
          dense
          :label="'Item No'"
          v-model="result.rbu_item.dummy_item_no"
          :rules="requiredRules"
        ></v-text-field>

        <v-text-field
          outlined
          dense
          :label="'Work Nature'"
          v-model="result.rbu_item.printed_remarks"
        ></v-text-field>

        <v-text-field
          outlined
          dense
          :label="'Action Description'"
          v-model="result.rbu_item.printed_description"
        ></v-text-field>

        <v-text-field
          outlined
          dense
          :label="'Rate Range'"
          v-model="result.rbu_item.unit_desc"
        ></v-text-field>

        <v-text-field
          outlined
          dense
          :label="'unit'"
          v-model="result.rbu_item.unit"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="$refs.form.validate() && save()"
        depressed
        large
      >
        {{ $t("ok") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ref } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";

export default {
  name: "EditDescriptionDialog",
  props: {
    a_sor_id: String,
    rbu_item: Object,
  },
  setup(props, { root, emit }) {
    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
      (value) =>
        (!!value && !!value.match(/^\d+(\.\d+)?[A-L]$/)) ||
        `Item No. must ends with [A-L]`,
    ]);
    const result = ref({
      a_sor_id: props.a_sor_id,
      rbu_item: props.rbu_item,
    });

    const save = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/a_sor/edit_rbu_item_description/",
        params: {
          ...result.value,
        },
      });

      if (response.body.success) {
        emit("submit", response.body.success);
      }
    };

    return {
      requiredRules,
      result,
      save,
      props,
    };
  },
};
</script>
